<template>
  <div>
    <div :class="$style.heading">
      <lv-heading tag="h3" level="3" version2>
        {{ $awt('aw.common.product.parameters.title') }}
      </lv-heading>
    </div>
    <div v-if="parameters">
      <dl :class="$style.table">
        <template v-for="(parameter, idx) in parameters" :key="parameter.id">
          <dt
            :class="[
              $style.tableElement,
              {
                [$style.tableElementLast]: idx === (parameters.length-1),
              }
            ]"
            v-text="parameter.name"
          />
          <dd
            :class="[
              $style.tableElement,
              {
                [$style.tableElementLast]: idx === (parameters.length-1),
              }
            ]"
          >
            <template v-if="parameter.type === 'image'">
              <span class="awSrOnly" v-text="$awt('aw.global.yes')" />
              <aw-base64-icon
                :source="parameter.value"
                :size="72"
                aria-hidden="true"
              />
            </template>
            <template v-else>
              {{ parameter.value }}
            </template>
          </dd>
        </template>
      </dl>
    </div>
  </div>
</template>

<script setup>
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import AwBase64Icon from '~~/common/components/Common/AwBase64Icon';

  defineProps({
    parameters: {
      type: Array,
      required: true,
    },
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.heading {
  margin-bottom: 40px;

  @include mobile(max) {
    display: none;
  }
}

.table {
  display: grid;
  margin: 0;
  padding: 0;
  border: 1px solid $color-border-disabled;
  border-radius: 12px;
  background: $color-white;

  @include mobile(max) {
    margin-top: 20px;
  }

  @include tablet(min) {
    grid-template-columns: 1fr 1fr;
    border-radius: 16px;
  }

  &Element {
    font-size: 12px;
    line-height: 16px;
    margin: 0;
    padding: 0 12px;
    text-align: center;
    border-bottom: 1px solid $color-border-disabled;

    @include tablet(min) {
      font-size: 14px;
      line-height: 20px;
      padding: 12px 24px;
      text-align: left;
    }

    &:nth-child(odd) {
      font-weight: 900;

      @include mobile(max) {
        padding-top: 16px;
        padding-bottom: 8px;
        border-color: transparent;
      }
    }

    &:nth-child(even) {
      text-transform: capitalize;

      @include mobile(max) {
        padding-top: 8px;
        padding-bottom: 16px;
      }
    }

    &Last {
      border-bottom: none;
    }
  }
}
</style>
